Vendd.Scripts.load(function () {

    $('.x-control.x-sortbyselector[data-control="sorter"]').each(function (i, wrapper) {
        var $wrapper = $(wrapper);

        var isPagerAjax = $wrapper.data('ajax');

        var sortSelectBox = $wrapper.find('select');

        if (isPagerAjax) {
            var connectedListConnector = $wrapper.data('list');
            if (connectedListConnector === undefined)
                throw 'Connected list not declared for list sorter ' + $wrapper.attr('id');

            var $connectedList = $('.x-control[data-control="list"][data-list="' + connectedListConnector + '"]').first();

            sortSelectBox.change(function (e) {
                var selectedKey = $(this).find(":selected").data('key');
                if (selectedKey) {
                    var config = $connectedList.get(0).getConfiguration(); // chriss TODO

                    var selectedOption = $.Enumerable.From(config.LoaderData.SortOptions)
                        .Where(function (x) { return x.Key.toLowerCase() === selectedKey.toLowerCase(); })
                        .DefaultIfEmpty(null)
                        .FirstOrDefault();

                    config.LoaderData.SortBy = selectedOption;

                    $connectedList.get(0).load(config);
                }
            });
        }
        else {
            sortSelectBox.change(function (e) {
                var targetUrl = $(this).find(":selected").data('url');
                if (targetUrl)
                    document.location = targetUrl;
            });
        }
    });

});

